import GroupRule from './components/GroupRule'

import './styles.scss'

export {
  GroupRule
}
